import type { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';
import type { TechRadarRawData } from '@ns/plugin-ns-tech-radar-common';

/**
 * Transform the json-serialisable `TechRadarRawData` (with ISO-8601 string
 * dates) stored on `entity.spec.data` into the `TechRadarLoaderResponse`
 * shape consumed by `@backstage-community/plugin-tech-radar` (with `Date`
 * objects on timeline snapshots).
 */
export function transformRadarData(
  raw: TechRadarRawData,
): TechRadarLoaderResponse {
  return {
    entries: raw.entries.map(entry => ({
      ...entry,
      timeline: entry.timeline.map(snapshot => ({
        ...snapshot,
        date: new Date(snapshot.date),
      })),
    })),
    quadrants: raw.quadrants,
    rings: raw.rings,
  };
}
